export const photos = [
    {
        src: "/img/gallery/gallery-1.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-2.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 4898,
        height: 3266
    },
    {
        src: "/img/gallery/gallery-3.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3266,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-4.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3266,
        height: 4899
    },
    {
        src: "/img/gallery/gallery-5.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-6.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-7.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-8.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3266,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-9.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3266,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-15.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 854,
        height: 1280
    },
    {
        src: "/img/gallery/gallery-14.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 854,
        height: 1280
    },
    {
        src: "/img/gallery/gallery-10.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-11.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-12.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3266,
        height: 4898
    },
    {
        src: "/img/gallery/gallery-13.jpg",
        sizes: ["(min-width: 480px) 20vw, (min-width: 1024px) 15vw, 33.3vw"],
        width: 3265,
        height: 4898
    }
    

];
  